import jss from 'jss';

const styles = {
  sidebar: {
    maxHeight: 'calc(100vh - 69px)',
    padding: 15,
    width: 250,
    boxShadow: 'none'
  },
  sidebarItem: {
    maxHeight: 'calc(100vh - 69px)',
    marginBottom: 14,
    padding: 0,
    margin: 0,
    '& .nav-link': {
      padding: 0
    },
    '&.active .nav-link': {
      color: '#eb5424'
    }
  },
  sidebarParentItem: {
    marginBottom: 0
  },
  sidebarSubItem: {
    color: 'rgba(0,0,0,0.86)',
    letterSpacing: 0.3,
    fontSize: 13,
    marginBottom: 0,
    paddingLeft: 15,
    '& + $sidebarItem:not($sidebarSubItem)': {
      marginTop: 14
    }
  },
  header: {
    width: '100%',
    borderBottom: '1px solid #f1f1f1',
    background: 'rgba(255,255,255,0.9)',
    height: 69,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& img.brand': {
      maxHeight: 40,
      objectFit: 'contain',
      objectPosition: 'center'
    },
    padding: 15
  },
  headerBrand: {
    fontWeight: 'bold',
    color: 'rgb(151, 157, 166)'
  },
  root: {
    display: 'block',
    margin: '0 auto',
    padding: '0 15px',
    boxSizing: 'content-box'
  },
  app: {
    minHeight: 'calc(100vh - 69px)',
    position: 'relative',
    marginRight: 15,
    boxSizing: 'border-box'
  },
  content: {
    maxHeight: 'calc(100vh - 69px)',
    minHeight: 'calc(100vh - 69px)',
    position: 'relative',
    width: '100%',
    height: '100%'
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();



// WEBPACK FOOTER //
// ./src/app/styles.js